'use strict'

export class Forms {
    static send(form, event) {
        event.preventDefault()
        this.submitButtonDisabled(form, true)
        this.removeErrors(form)
        let data = new FormData(form)
        let xmlHttp = new XMLHttpRequest()
        xmlHttp.form = form
        xmlHttp.callback = this.callback
        xmlHttp.onreadystatechange = this.onreadystatechange
        xmlHttp.open('POST', BX.message('SITE_DIR') + 'ajax/')
        xmlHttp.responseType = 'json'
        xmlHttp.send(data)
        return true
    }

    static submitButtonDisabled(form, disabled) {
        let submitButton = form.querySelector("[type=submit]")
        if (submitButton) {
            if (disabled) {
                submitButton.disabled = true
                submitButton.classList.add('loading')
            } else {
                submitButton.disabled = false
                submitButton.classList.remove('loading')
            }
        }
    }

    // Удаляем все сообщения об ошибках формы.
    static removeErrors(form) {
        let errors = form.querySelectorAll('.input-items-error')
        errors.forEach(error => {
            error.remove()
        })
    }

    static onreadystatechange() {
        if (this.readyState === 4 && this.status === 200) {
            this.callback(this)
        }
    }

    static open(event, controller, popupId, ...args) {
        event.preventDefault()

        if (!TimeCity.formsInPage) {
            TimeCity.formsInPage = {}
        }

        /**
         * Если форма уже есть на странице
         **/
        if (TimeCity.formsInPage[popupId]) {
            $('#' + popupId).popup('show')
            return true
        }

        let data = {
            'controller': controller,
            'getPopup': 1,
            'popupId': popupId,
            //'languageId': BX.message('LANGUAGE_ID'),
        }
        if (args.length > 0) {
            data['args'] = JSON.stringify(args)
        }
        let xmlHttp = new XMLHttpRequest()
        xmlHttp.onreadystatechange = () => {
            if (xmlHttp.readyState === 4 && xmlHttp.status === 200 && xmlHttp.responseText) {
                /**
                 * В отличие от insertAdjacentHTML следующий код вставляет <script> и выполняет его.
                 * Поэтому используется он.
                 */
                document.body.prepend(document.createRange().createContextualFragment(xmlHttp.responseText))
                TimeCity.formsInPage[popupId] = true
                $('#' + popupId).popup({
                    scrolllock: true
                }).popup('show')
            }
        }
        xmlHttp.open('POST', BX.message('SITE_DIR') + 'ajax/')
        xmlHttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')
        let dataString = new URLSearchParams(Object.entries(data)).toString()
        xmlHttp.send(dataString)
        return true
    }
}